"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class MerchantPrinterApi {
    constructor(api) {
        this.api = api;
    }
    getPrinterSetting() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosNode.get('/m/merchant/printersetting');
            return response.data;
        });
    }
    // 覆寫 printer setting
    updatePrinterSetting(printerSetting) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosNode.post('/m/merchant/printersetting', { data: JSON.stringify(printerSetting) });
            return response.data;
        });
    }
    // 更改自動確認打印開關
    updatePrinterAutoConfirm(autoconfirm) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/autoconfirm', { value: autoconfirm });
            return response.data;
        });
    }
    // 外賣提示音次數 count -1 表示無限次
    updateTakeawayNotifyAudioPlayCount(count) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/takeawaynotifyaudioplaycount', { value: count });
            return response.data;
        });
    }
    // 外送提示音次數 count -1 表示無限次
    updateStoreDeliveryNotifyAudioPlayCount(count) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.axiosGo.post('/m/merchant/setting/storedeliverynotifyaudioplaycount', { value: count });
            return response.data;
        });
    }
}
exports.default = MerchantPrinterApi;
//# sourceMappingURL=MerchantPrinter.js.map